import webAPIServices from "./webAPIServices";

export async function GetCategoriasProductos() {
  const appsvc = new webAPIServices();

  let requestUrl = `/categoriasproductos`;

  return appsvc.Get(requestUrl);
}

export async function GetCategoriaProductos(name) {
    const appsvc = new webAPIServices();
    let requestUrl = `/categoriasproductos/${name}`;
    return appsvc.Get(requestUrl);
}

export async function UpdateCategoriaProductos(categoria) {
    const appsvc = new webAPIServices();
    // Most write operations use the /backoffice prefix across the app
    let requestUrl = `/categoriasproductos/${categoria.id}`;
    // Align payload casing and sanitize new subcategory ids
    const subCategorias = Array.isArray(categoria.subCategorias)
      ? categoria.subCategorias.map((s) => ({
          Id: Number.isFinite(Number(s.id)) ? Number(s.id) : 0,
          Nombre: s.nombre,
          Orden: s.orden,
        }))
      : [];
    let body = { categoriaProductoId: categoria.id, subCategorias };
    return appsvc.Put(requestUrl, body);
}
